import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { uniqueId } from 'lodash';
import SwaggerUIBundle from 'swagger-ui'; // eslint-disable-line
import { CurrentUserProps } from '../props/currentUser';

const propTypes = {
  specs: PropTypes.string,
  currentUser: CurrentUserProps
};

export default class Documentation extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      docId: `api-docs-${uniqueId()}`
    };

    this.renderDocs = this.renderDocs.bind(this);
  }

  componentDidMount() {
    this.renderDocs();
  }

  renderDocs() {
    const swagger = SwaggerUIBundle({
      dom_id: `#${this.state.docId}`,
      url: this.props.specs,
      deepLinking: true,
      defaultModelExpandDepth: 2,
      defaultModelsExpandDepth: 1,
      displayOperationId: true,
      supportedSubmitMethods: ['get'],
      requestInterceptor: (request) => {
        if (request.loadSpec) {
          // Intercept the spec and replace the *_HOST with the correct one for the ENV we're running in.
          request.responseInterceptor = (response) => {
            // RIDB_HOSTS
            response.body.servers[0].url = response.body.servers[0].url.replace('RIDB_HOST', process.env.RIDB_ROOT);
            response.obj.servers[0].url = response.obj.servers[0].url.replace('RIDB_HOST', process.env.RIDB_ROOT);
            response.data = response.data.replace('RIDB_HOST', process.env.RIDB_ROOT);
            response.text = response.text.replace('RIDB_HOST', process.env.RIDB_ROOT);

            // API_HOSTS
            response.body.servers[0].url = response.body.servers[0].url.replace('API_HOST', process.env.API_ROOT);
            response.obj.servers[0].url = response.obj.servers[0].url.replace('API_HOST', process.env.API_ROOT);
            response.data = response.data.replace('API_HOST', process.env.API_ROOT);
            response.text = response.text.replace('API_HOST', process.env.API_ROOT);

            return response;
          };
        }

        return request;
      },
      onComplete: () => {
        // Automatically set the developers ApiKey
        setTimeout(() => {
          const { isDeveloper, apiKey: { apiKey } } = this.props.currentUser;
          if (isDeveloper) {
            swagger.preauthorizeApiKey('Apikey', apiKey);
          }
        }, 10);
      }
    });
  }

  render() {
    const { docId } = this.state;

    return (
      <div>
        <div id={docId} />
      </div>
    );
  }
}

Documentation.propTypes = propTypes;
